import sharedConstants from "@lib/shared_constants";

export const AUTH_TYPE_KEY = sharedConstants.FIELD_LEVEL_ENCRYPTION.AUTH_TYPE_KEY;
export const AUTH_TYPE_ROLE = sharedConstants.FIELD_LEVEL_ENCRYPTION.AUTH_TYPE_ROLE;

interface EncryptionSettings {
  access_key_id?: string;
  access_secret?: string;
  hmac_key_id?: string;
  auth_type?: string;
  role_arn?: string;
  external_id?: string;
}

export interface UserDataEncryptionSettingsResult {
  present: boolean;
  is_workspace_compatible: boolean;
  data: Required<EncryptionSettings> & { account_id: string };
}

export interface PostAppsAppGroupIdEncryptionSettingsProps {
  app_group_id: string;
  data: EncryptionSettings;
}

export interface PostUserDataEncryptionSettingsResult {
  info: string;
}

export interface GenerateExternalIdResult {
  external_id: string;
  account_id: string;
}
